import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  ChangeRootDialogData,
  ChangeRootDialogResult,
} from '../../../Interfaces/change-root-dialog.interface';

@Component({
  selector: 'app-change-root-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './change-root-dialog.component.html',
  styleUrl: './change-root-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeRootDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<ChangeRootDialogComponent, ChangeRootDialogResult>>(MatDialogRef);

  readonly data = inject<ChangeRootDialogData>(MAT_DIALOG_DATA);

  readonly formGroup: FormGroup = this._formBuilder.group({ override: [false] });

  private readonly _override = signal<boolean>(false);

  readonly overrideRequired = computed<boolean>(() => !this.data.ownsCoreSeat);

  readonly overrideBlocked = computed<boolean>(
    () => this.overrideRequired() && this.data.hasEligibleCandidate,
  );

  readonly canConfirm = computed<boolean>(() => {
    if (!this.overrideRequired()) {
      return true;
    }

    return this._override() && !this.overrideBlocked();
  });

  toggleOverride(checked: boolean): void {
    this._override.set(checked);
  }

  confirm(): void {
    if (!this.formGroup.valid || !this.canConfirm()) {
      return;
    }

    this._dialogRef.close({ override: Boolean(this.formGroup.value.override) });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
